import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CTEModel, loteDetails, preLoteDetails, requestSelecionarItensGridAcao } from 'src/app/@shared/models/gestao-de-cte/gestao-de-cte.model';
import { requestGerarLotes } from 'src/app/@shared/models/manutencao-envio-cte';

import { BaseRelService } from '../base-rel/base-rel.service';
import { montarQueryString } from '../base/base.service';

@Injectable({
  providedIn: 'root'
})
export class ManutencaoCTEService extends BaseRelService {
  //armazena qual o tipo de Acao

  /*
    Informar a rota do Controller correspondente na API
    */
  apiController = "GestaoCTe";

  /*
  URLS principais
  */
  consultarUrl = (input: CTEModel) => `FiltrarGridPrincipal?${montarQueryString(input)}`;
  excelUrl = (input: CTEModel) => `ExportarExcelGridPrincipal/${input.identificador ?? ""}?${montarQueryString(input)}`;

  constructor(public override http: HttpClient) {
    super(http);
  }

  public getPesos(input: object): Observable<any> {
    return this.post(`CarregarPesoCTe?${montarQueryString(input)}`, input);
  }
  public getPesosExcel(input): Observable<any[]> {
    return this.get<any[]>(`ExportarExcelPesoCTe?${montarQueryString(input)}`)
  };
  public getAcaoExcel(identificador: string, input): Observable<any[]> {
    return this.get<any[]>(`ExportarExcelGridPrincipal/${identificador}/?${montarQueryString(input)}`)
  };
  public getReceitas(): Observable<any[]> {
    return this.get<any[]>(`consulta`, 'Receita')
  };
  public consultaStatusCancelamento(): Observable<any> {
    return this.get<any>(`ConsultaStatusCancelamento`);
  }
  public consultaFilialEmissao(): Observable<any> {
    return this.get<any>(`ConsultaFilialEmissao`);
  }
  public exportarTemplate(id: number): Observable<any> {
    return this.get<any>(`exportarTemplate/${id}`);
  }
  public checarPreLoteAtivo(acao): Observable<any> {
    return this.get<any>(`ChecarPreLoteAtivo/${acao}`);
  }
  public filtrarGridPrincipalViaUpload(identificador, obj: any): Observable<any> {
    return this.get<any>(`FiltrarGridPrincipalViaUpload/${identificador}?${montarQueryString(obj)}`);
  }
  public gerarPreLoteViaUpload(tipo: number, obj: object): Observable<any> {
    return this.post(`gerarPreLoteViaUpload/${tipo}`, obj);
  }

  public gerarPreLoteViaFiltros(tipo: number, obj: object): Observable<any> {
    return this.post(`GerarPreLoteViaFiltros/${tipo}`, obj);
  }

  public deletarPreLote(identificador): Observable<any> {
    return this.delete(`PreLote/${identificador}`);
  }
  public salvarDocumentoGestao(obj): Observable<any> {
    return this.post(`SalvarDocumentoGestao/`, obj);
  }
  public gerarPreloteErro(obj): Observable<any> {
    return this.post(`GerarPreLoteViaErrosCTe/`, obj);
  }
  public consultaStatusCTE(): Observable<any> {
    return this.get<any>(`ConsultaStatusCTE`);
  }
  public consultaAcoesCTE(): Observable<any> {
    return this.get<any>(`ConsultaAcoesCTE`);
  }

  public filtrarGridAcao(identificador, obj): Observable<any> {
    return this.get<any>(`PreLote/${identificador}/Itens?${montarQueryString(obj)}`);
  }

  public obterPreLoteCards(obj): Observable<any> {
    return this.get<any>(`PreLote/${obj.identificador}/Cards?confirmacao=${obj.confirmacao}`);
  }

  public obterPreLoteDetails(identificador): Observable<preLoteDetails> {
    return this.get<preLoteDetails>(`PreLote/${identificador}`);
  }

  public validarPreLote(identificador): Observable<HttpResponse<preLoteDetails>> {
    return this.post<preLoteDetails>(`PreLote/${identificador}/Validar`, {});
  }

  public consultarSugestaoLotes(identificador: string): Observable<any> {
    return this.get<any>(`PreLote/${identificador}/SugestaoLotes`);
  }

  public gerarLotes(obj: requestGerarLotes): Observable<any> {
    return this.post<any>(`GerarLotes`, obj);
  }

  public filtrarGridLotes(identificador, obj): Observable<any> {
    return this.get<any>(`Lote/${identificador}/Itens?${montarQueryString(obj)}`);
  }

  public exportarGridPreLotes(identificador, obj): Observable<any> {
    return this.get<any>(`PreLote/${identificador}/ItensExcel?${montarQueryString(obj)}`);
  }

  public exportarGridLotes(identificador, obj): Observable<any> {
    return this.get<any>(`Lote/${identificador}/ItensExcel?${montarQueryString(obj)}`);
  }

  public obterLoteCards(obj): Observable<any> {
    return this.get<any>(`Lote/${obj.identificador}/Cards?confirmacao=${obj.confirmacao}`,);
  }

  public obterLoteDetails(identificador): Observable<loteDetails> {
    return this.get<loteDetails>(`Lote/${identificador}`);
  }

  public selecionarItensGridAcao(obj: requestSelecionarItensGridAcao): Observable<any> {
    return this.put<any>(`SelecionarItensGridAcao`, obj);
  }

  public selecionarItensReemisao(obj: requestSelecionarItensGridAcao): Observable<any> {
    return this.put<any>(`MarcarItensReemissao`, obj);
  }

  public atualizarDeclaracao(obj): Observable<any> {
    return this.post<any>(`AtualizarDeclaracao`, obj);
  }

  public preLoteRecalcularFrete(obj): Observable<any> {
    return this.post<any>(`PreLoteRecalcularFrete`, obj);
  }

  public preLoteReemissao(obj): Observable<any> {
    return this.post<any>(`Reemissao`, obj);
  }

  public consultaTipoPeso(): Observable<any> {
    return this.get<any>(`OrigensPesos`);
  }

  public preLoteDesconto(obj): Observable<any> {
    return this.post<any>(`PreLoteDesconto`, obj);
  }

  public preLoteClientes(identificador: string): Observable<any> {
    return this.get<any>(`PreLote/${identificador}/Clientes`);
  }

  public preLoteTabelaPreco(idTabelaPreco: Number, cepOrigem: string, cepDestino: string): Observable<any> {
    return this.get<any>(`ConsultaTabelaPreco/${idTabelaPreco}/${cepOrigem}/${cepDestino}`);
  }

}
